import { Col, Modal, Row, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetPlansDetailsApi from "../../../api/plans/GetPlanDetailsApi";
import PlanOverview from "../../top-plan/PlanOverview";
import TopPlanKpi from "../../top-plan/TopPlanKpi";
import TopPlanOverview from "../../top-plan/TopPlanOverview";
import TopPlanTasks from "../../top-plan/TopPlanTasks";

const { TabPane } = Tabs;

function SplitPlanInfoModal(props) {
  const [planDetails, setPlanDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    if (props.visible && props.plan?.planId) {
      fetchPlanDetails();
    }
  }, [props.visible, props.plan?.planId]);

  async function fetchPlanDetails() {
    setLoading(true);
    try {
      const apiResponse = await GetPlansDetailsApi(props.plan.planId, positionState?.id);
      if (apiResponse.message === "success") {
        setPlanDetails(apiResponse.plan);
      }
    } catch (error) {
      console.error("Error fetching plan details:", error);
    } finally {
      setLoading(false);
    }
  }

  // Use detailed plan data if available, otherwise fall back to props.plan
  const planData = planDetails || props.plan;

  return (
    <Modal
      title={planData?.title}
      visible={props.visible}
      onCancel={() => props.handleCancel()}
      footer={null}
      width={900}
    >
      <Tabs defaultActiveKey="1" centered>
        <TabPane tab={<div className="w-32 text-center">Overview</div>} key="1">
          <div className="px-6">
            <PlanOverview
              data={planData}
              updateTarget={(target) => props.updateTarget && props.updateTarget(target)}
            />
          </div>
        </TabPane>
        {planData?.kpi && (
          <TabPane tab={<div className="w-32 text-center">KPIs</div>} key="2">
            <div className="px-6">
              <TopPlanKpi data={planData} />
            </div>
          </TabPane>
        )}
        {planData?.tasks && (
          <TabPane tab={<div className="w-32 text-center">Tasks</div>} key="3">
            <div className="px-6">
              <TopPlanTasks data={planData} />
            </div>
          </TabPane>
        )}
      </Tabs>
    </Modal>
  );
}
export default SplitPlanInfoModal;
